import { useEffect, useRef } from "react";

// LIFO stack of overlay close handlers. Each returns true if it handled (closed something).
const handlers = [];

export function pushBackHandler(fn) {
  handlers.push(fn);
  return () => {
    const i = handlers.indexOf(fn);
    if (i >= 0) handlers.splice(i, 1);
  };
}

// Called by the native back button: try the open overlays first (top of stack downwards).
export function runTopBackHandler() {
  for (let i = handlers.length - 1; i >= 0; i--) {
    try { if (handlers[i]()) return true; } catch { /* noop */ }
  }
  return false;
}

// Register `handler` on the back stack while `active` is true. `handler` should close
// the overlay and return true when it consumed the back press.
export function useBackHandler(active, handler) {
  const ref = useRef(handler);
  ref.current = handler;
  useEffect(() => {
    if (!active) return undefined;
    return pushBackHandler(() => ref.current());
  }, [active]);
}
